import { FSMConfigVehicleSE, FSMOptionsVehicleSE } from './qb/vehicle/config'
import { FSMVehicleStatePathsSE } from './qb/vehicle/routes'
import { FSMInputType } from '../../../types/FSM'
import { FSMConfigFNOLVehicleSE, FSMOptionsFNOLVehicleSE } from './fnol/vehicle/config'
import { FSMFNOLVehicleStatePathsSE } from './fnol/vehicle/routes'
import { FlowName } from '../../../config'
import { ProductName } from '../../../types/interface/quote.interface'

const BrandFSMInput: Partial<FSMInputType> = {
  [FlowName.QUOTE_AND_BUY]: {
    [ProductName.VEHICLE]: {
      config: FSMConfigVehicleSE,
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      options: FSMOptionsVehicleSE,
      routes: FSMVehicleStatePathsSE,
    },
  },
  [FlowName.FNOL]: {
    [ProductName.VEHICLE]: {
      config: FSMConfigFNOLVehicleSE,
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      options: FSMOptionsFNOLVehicleSE,
      routes: FSMFNOLVehicleStatePathsSE,
    },
  },
}

export default BrandFSMInput
